import React from 'react';
import { useMutation } from 'react-query';

import { adminAPI } from '../../../../api';
import useModal from '../../../../context/ModalContext';
import useAlarm from '../../../../context/AlarmContext';
import FormLoader from '../../../../components/FormLoader';

const RemoveModalRepresentative = ({ ids, cohortId, refetch, refetchRepresentatives, setCheckedRepresentatives, checkedAllRepresentatives }) => {
  const { setAlarm } = useAlarm();
  const { closeModal } = useModal();

  const { mutate: removeRepresentativesMutation, isLoading: isRemoving } = useMutation(
    adminAPI.removeRepresentativesFromCohort,
    {
      onSuccess: () => {
        refetch();
        setAlarm({ type: 'success', message: `Representative${ids.length !== 1 ? 's' : ''} removed successfully` });
        refetchRepresentatives();
        setCheckedRepresentatives([]);
        closeModal();
      },
      onError: (error) => {
        setAlarm({ type: 'error', message: error.message });
        closeModal();
      },
    }
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    if (checkedAllRepresentatives) {
      removeRepresentativesMutation({ id: cohortId, cohort: { userEmails: [] } });
    } else {
      removeRepresentativesMutation({ id: cohortId, cohort: { userEmails: ids.map((representative) => representative.email) } });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="flex justify-between">
          <strong>Are you sure you want to remove this representative{ids.length > 1 || checkedAllRepresentatives ? 's' : ''}?</strong>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={closeModal}
              className="font-semibold p-4 rounded-lg bg-gray text-black mr-2"
            >
              No
            </button>
            <button
              type="submit"
              className="font-semibold p-4 rounded-lg bg-red text-white"
              disabled={isRemoving}
            >
              {isRemoving ? 'Removing...' : 'Yes'}
            </button>
          </div>
        </div>
      </form>
      {isRemoving && <FormLoader />}
    </>
  );
};

export default RemoveModalRepresentative;
